module.exports = __webpack_public_path__ + "img/payments.3b88dc39.svg";